const leaders = [
    {
      id: "1",
      num: "#1",
      teamName: "A",
      modelName: "Ensemble",
      submissionDate: "2022. 12. 18.",
      accuracy: "96.00",
      f1score: "91.92",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "2",
      num: "#2",
      teamName: "k-doritos",
      modelName: "k-doritos",
      submissionDate: "2022. 12. 14.",
      accuracy: "95.54",
      f1score: "91.72",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "3",
      num: "#3",
      teamName: "Baseline",
      modelName: "KLUE-Roberta (base)",
      submissionDate: "2022. 11. 14.",
      accuracy: "95.43",
      f1score: "90.93",
      badgeclass: "warning",
      etc: "BASELINE",
    },
    {
      id: "4",
      num: "#4",
      teamName: "Eugene Jang",
      modelName: "Eugene Jang",
      submissionDate: "2022. 12. 14.",
      accuracy: "95.50",
      f1score: "89.28",
      badgeclass: "",
      etc: "",
    },
    {
      id: "5",
      num: "#5",
      teamName: "jx2",
      modelName: "JuPTA",
      submissionDate: "2022. 12. 18.",
      accuracy: "95.22",
      f1score: "89.04",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "6",
      num: "#6",
      teamName: "immersion",
      modelName: "immersion",
      submissionDate: "2022. 12. 8.",
      accuracy: "95.59",
      f1score: "88.14",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "7",
      num: "#7",
      teamName: "Donut_Lovers",
      modelName: "Plain_Bagel",
      submissionDate: "2022. 12. 12.",
      accuracy: "92.87",
      f1score: "79.66",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "8",
      num: "#8",
      teamName: "KAIST MOOTLAB",
      modelName: "GHS",
      submissionDate: "2022. 12. 23.",
      accuracy: "93.11",
      f1score: "73.55"
    },
    {
      id: "9",
      num: "#9",
      teamName: "쏘타",
      modelName: "2text",
      submissionDate: "2022. 12. 11.",
      accuracy: "86.92",
      f1score: "60.56",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "10",
      num: "#10",
      teamName: "SY",
      modelName: "SY",
      submissionDate: "2022. 12. 19.",
      accuracy: "72.01",
      f1score: "42.41"
    },
    {
      id: "11",
      num: "#11",
      teamName: "sktoyo",
      modelName: "sktoyo",
      submissionDate: "2022. 12. 13.",
      accuracy: "60.15",
      f1score: "31.38",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "12",
      num: "#12",
      teamName: "JH",
      modelName: "JH",
      submissionDate: "2022. 12. 19.",
      accuracy: "23.17",
      f1score: "9.67"
    },
    {
      id: "13",
      num: "#13",
      teamName: "KAIST MOOTLAB",
      modelName: "GHS",
      submissionDate: "2022. 12. 18.",
      accuracy: "7.47",
      f1score: "0.08",
      badgeclass: "primary",
      etc: "CHALLENGE",
    },
    {
      id: "14",
      num: "#14",
      teamName: "Oily",
      modelName: "Oily",
      submissionDate: "2022. 12. 18.",
      accuracy: "3.31",
      f1score: "0.04",
      badgeclass: "primary",
      etc: "CHALLENGE",
    }
  ];
//badgeclass - secondary, primary, warning, success
  
export default leaders;